module.exports = __webpack_public_path__ + "img/icon-home.efb81da9.svg";